import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import debounce from "lodash.debounce";
import { listMonthlyReportPdfService } from "../service/listMonthlyReportPdf.service";

const LIMIT = 25;

export const useMonthlyReportPdfQuery = (filters) => {
  const fetchData = useFetch();
  const [monthlyReportPdf, setMonthlyReportPdf] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchMonthlyReportPdf = async () => {
      setLoading(true);
      try {
        const response = await listMonthlyReportPdfService(fetchData)({
          offset: (page - 1) * LIMIT,
          limit: LIMIT,
          ...filters,
        });
        setMonthlyReportPdf(response.data);
        setTotal(response.total);
        setTotalPages(response.totalPages);
      } catch (error) {
        console.error("Error fetching monthly report PDF:", error);
      } finally {
        setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchMonthlyReportPdf, 500);
    debouncedFetch();

    return () => {
      debouncedFetch.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, page, refresh]);

  return {
    monthlyReportPdf,
    loading,
    page,
    onChangePage: (newPage) => setPage(newPage),
    total,
    totalPages,
    refresh: () => setRefresh((prev) => !prev),
  };
};
